import React, { useState } from 'react';
import axios from 'axios'; // Si aún no lo has instalado: npm install axios
import { api } from '../../Users/user';
import { toast } from '@ohif/ui-next';

interface Server {
  _id: string;
  host: string;
  port: number;
  calledAET: string;
  callingAET: string;
  isDefault: boolean;
}

const ServerItem = ({
  server,
  onDelete,
  onSetDefault,
  onEdit,
}: {
  server: Server;
  onDelete: any | void;
  onSetDefault: any | void;
  onEdit: any | void;
}) => {
  const [loading, setLoading] = useState(false); // Estado para mostrar carga

  // Función para manejar la solicitud de ping
  const handlePing = async () => {
    setLoading(true); // Inicia la carga
    try {
      // Realiza la solicitud POST al backend
      const res = await axios.post(api + '/api/dicom/ping', {
        host: server.host,
        port: server.port,
        calledAET: server.calledAET,
        callingAET: server.callingAET,
      });
      console.log(res.data);
      toast.success(res.data.message || 'Ping exitoso');
      // Si la respuesta es exitosa, muestra el mensaje
    } catch (error: any) {
      toast.warning(error.response?.data?.message || 'Ping exitoso');
      // Si ocurre un error, muestra un mensaje de error
    } finally {
      setLoading(false); // Detiene el estado de carga
    }
  };
  const handle = id => {
    handlePing();
    onSetDefault(id);
  };
  return (
    <li className="bg-primary-main hover:bg-primary-main/80 mb-3 flex items-center space-x-4 rounded-lg p-4 transition">
      <div className="flex-1 text-white">
        <strong className="text-lg">
          {server.host}:{server.port}
        </strong>{' '}
        - {server.callingAET}/{server.calledAET}
        {server.isDefault && (
          <span className="ml-2 text-sm font-bold text-yellow-400">(Por defecto)</span>
        )}
      </div>
      <div className="flex flex-col space-y-4 sm:flex-row sm:flex-wrap sm:justify-center sm:space-y-2 sm:space-x-4">
        {/* Botón de Editar */}
        <button></button>
        <button
          onClick={() => onEdit(server)}
          className="flex w-full items-center justify-center rounded-md bg-blue-600 px-6 py-3 text-lg font-semibold text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-red-500 sm:w-auto sm:text-base"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="currentColor"
            className="bi bi-pencil mr-2"
            viewBox="0 0 16 16"
          >
            <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325" />
          </svg>
        </button>

        {/* Botón de Eliminar */}
        <button
          onClick={() => onDelete(server._id)}
          className="flex w-full items-center justify-center rounded-md bg-red-600 px-6 py-3 text-lg font-semibold text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 sm:w-auto sm:text-base"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="currentColor"
            className="bi bi-trash3-fill mr-2"
            viewBox="0 0 16 16"
          >
            <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5m-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5M4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06m6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528M8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5" />
          </svg>
        </button>

        {/* Botón de "Escuchar" */}
        <button
          onClick={handlePing}
          className="flex w-full items-center justify-center rounded-md bg-blue-600 px-6 py-3 text-lg font-semibold text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 sm:w-auto sm:text-base"
          disabled={loading} // Deshabilita el botón mientras está cargando
        >
          {loading ? (
            <>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="currentColor"
                className="bi bi-arrow-clockwise mr-2 animate-spin"
                viewBox="0 0 16 16"
              >
                <path d="M8 3a5 5 0 0 1 4.546 3h-1.14a3.75 3.75 0 1 0-6.812 0H3.454A5 5 0 0 1 8 3z" />
              </svg>
              Escuchando...
            </>
          ) : (
            'Escuchar'
          )}
        </button>

        {/* Botón de Establecer como Predeterminado */}
        {!server.isDefault && (
          <button
            onClick={() => handle(server._id)}
            className="flex w-full items-center justify-center rounded-md bg-yellow-600 px-6 py-3 text-lg font-semibold text-white hover:bg-yellow-700 focus:outline-none focus:ring-2 focus:ring-yellow-500 sm:w-auto sm:text-base"
          >
            Establecer por defecto
          </button>
        )}
      </div>
    </li>
  );
};

export default ServerItem;
